// extracted by mini-css-extract-plugin
module.exports = {"link":"_1GHvV","root":"_3IThy","label":"_1MugV"};